import type { CSSProperties, ReactNode } from 'react';
import { Tag, Tooltip } from 'antd';
import { COLOR } from '@styles/theme';

export function coloredTagStyle(color?: string): CSSProperties {
  const base: CSSProperties = {
    margin: 0,
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1.25,
  };
  if (!color) return base;
  return {
    ...base,
    backgroundColor: color,
    borderColor: color,
    color: COLOR.white,
  };
}

type PalletTagProps = {
  children: ReactNode;
  color?: string;
  className?: string;
  style?: CSSProperties;
};

export function PalletTag({ children, color, className, style }: PalletTagProps) {
  return (
    <Tag className={className} style={{ ...coloredTagStyle(color), ...style }}>
      {children}
    </Tag>
  );
}

type UsedAsStoragePillProps = {
  usedAsStorage?: boolean;
  className?: string;
};

export const UsedAsStoragePill = ({
  usedAsStorage,
  className,
}: UsedAsStoragePillProps) => {
  if (!usedAsStorage) {
    return null;
  }

  return (
    <Tooltip title="This Pallet is being used for storage, it cannot be used for picking">
      <span className={className} style={{ display: 'inline-flex', cursor: 'default' }}>
        <PalletTag>Storage</PalletTag>
      </span>
    </Tooltip>
  );
};
